export const base64Encode = (str: string = ""): string => {
  const buffer = Buffer.from(str);
  return buffer.toString("base64");
};
